import {
  Companion_getInstance210kkjgxlt93z as Companion_getInstance,
  OauthClientSecret2j9geext0n7q2 as OauthClientSecret,
} from './models.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareOauthClientSecretFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [OauthClientSecret_createdAt_getInstance(), OauthClientSecret_masked_getInstance(), OauthClientSecret_secretHash_getInstance(), OauthClientSecret_disabledAt_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function OauthClientSecret_createdAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function OauthClientSecret_createdAt$_get_name_$ref_f09w3p() {
  return (p0) => p0.k20();
}
function OauthClientSecret_createdAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClientSecret_createdAt$_get_serializer_$ref_e1q8f6() {
  return (p0) => p0.j2j();
}
function OauthClientSecret_createdAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function OauthClientSecret_createdAt$_get_annotations_$ref_pelzq2() {
  return (p0) => p0.bz();
}
var OauthClientSecret_createdAtClass;
function OauthClientSecret_createdAt() {
  if (OauthClientSecret_createdAtClass === VOID) {
    class $ {
      constructor() {
        OauthClientSecret_createdAt_instance = this;
        var tmp = this;
        tmp.g2o_1 = lazy(OauthClientSecret_createdAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h2o_1 = lazy(OauthClientSecret_createdAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i2o_1 = lazy(OauthClientSecret_createdAt$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.j2o_1 = get_default(Companion_instance).d1m();
        this.k2o_1 = 'now()';
      }
      k20() {
        var tmp0 = this.g2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClientSecret_createdAt$_get_name_$ref_f09w3p(), null);
        return tmp0.f2();
      }
      l2o(receiver) {
        return receiver.m2o_1;
      }
      m2j(receiver) {
        return this.l2o(receiver instanceof OauthClientSecret() ? receiver : THROW_CCE());
      }
      q2o(receiver, value) {
        return receiver.r2o(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OauthClientSecret() ? receiver : THROW_CCE();
        return this.q2o(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClientSecret_createdAt$_get_serializer_$ref_e1q8f6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClientSecret_createdAt$_get_annotations_$ref_pelzq2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClientSecret_createdAt', VOID, VOID, [SerializableProperty()]);
    OauthClientSecret_createdAtClass = $;
  }
  return OauthClientSecret_createdAtClass;
}
var OauthClientSecret_createdAt_instance;
function OauthClientSecret_createdAt_getInstance() {
  if (OauthClientSecret_createdAt_instance === VOID)
    new (OauthClientSecret_createdAt())();
  return OauthClientSecret_createdAt_instance;
}
function OauthClientSecret_masked$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function OauthClientSecret_masked$_get_name_$ref_o4091h() {
  return (p0) => p0.k20();
}
function OauthClientSecret_masked$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClientSecret_masked$_get_serializer_$ref_4sxdm4() {
  return (p0) => p0.j2j();
}
function OauthClientSecret_masked$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function OauthClientSecret_masked$_get_annotations_$ref_my7ols() {
  return (p0) => p0.bz();
}
var OauthClientSecret_maskedClass;
function OauthClientSecret_masked() {
  if (OauthClientSecret_maskedClass === VOID) {
    class $ {
      constructor() {
        OauthClientSecret_masked_instance = this;
        var tmp = this;
        tmp.s2o_1 = lazy(OauthClientSecret_masked$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t2o_1 = lazy(OauthClientSecret_masked$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u2o_1 = lazy(OauthClientSecret_masked$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.s2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClientSecret_masked$_get_name_$ref_o4091h(), null);
        return tmp0.f2();
      }
      l2o(receiver) {
        return receiver.n2o_1;
      }
      m2j(receiver) {
        return this.l2o(receiver instanceof OauthClientSecret() ? receiver : THROW_CCE());
      }
      v2o(receiver, value) {
        return receiver.r2o(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OauthClientSecret() ? receiver : THROW_CCE();
        return this.v2o(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.t2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClientSecret_masked$_get_serializer_$ref_4sxdm4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClientSecret_masked$_get_annotations_$ref_my7ols(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClientSecret_masked', VOID, VOID, [SerializableProperty()]);
    OauthClientSecret_maskedClass = $;
  }
  return OauthClientSecret_maskedClass;
}
var OauthClientSecret_masked_instance;
function OauthClientSecret_masked_getInstance() {
  if (OauthClientSecret_masked_instance === VOID)
    new (OauthClientSecret_masked())();
  return OauthClientSecret_masked_instance;
}
function OauthClientSecret_secretHash$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function OauthClientSecret_secretHash$_get_name_$ref_fu9n20() {
  return (p0) => p0.k20();
}
function OauthClientSecret_secretHash$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClientSecret_secretHash$_get_serializer_$ref_rcsobj() {
  return (p0) => p0.j2j();
}
function OauthClientSecret_secretHash$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function OauthClientSecret_secretHash$_get_annotations_$ref_br1cql() {
  return (p0) => p0.bz();
}
var OauthClientSecret_secretHashClass;
function OauthClientSecret_secretHash() {
  if (OauthClientSecret_secretHashClass === VOID) {
    class $ {
      constructor() {
        OauthClientSecret_secretHash_instance = this;
        var tmp = this;
        tmp.w2o_1 = lazy(OauthClientSecret_secretHash$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x2o_1 = lazy(OauthClientSecret_secretHash$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y2o_1 = lazy(OauthClientSecret_secretHash$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.w2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClientSecret_secretHash$_get_name_$ref_fu9n20(), null);
        return tmp0.f2();
      }
      l2o(receiver) {
        return receiver.o2o_1;
      }
      m2j(receiver) {
        return this.l2o(receiver instanceof OauthClientSecret() ? receiver : THROW_CCE());
      }
      v2o(receiver, value) {
        return receiver.r2o(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OauthClientSecret() ? receiver : THROW_CCE();
        return this.v2o(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClientSecret_secretHash$_get_serializer_$ref_rcsobj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClientSecret_secretHash$_get_annotations_$ref_br1cql(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClientSecret_secretHash', VOID, VOID, [SerializableProperty()]);
    OauthClientSecret_secretHashClass = $;
  }
  return OauthClientSecret_secretHashClass;
}
var OauthClientSecret_secretHash_instance;
function OauthClientSecret_secretHash_getInstance() {
  if (OauthClientSecret_secretHash_instance === VOID)
    new (OauthClientSecret_secretHash())();
  return OauthClientSecret_secretHash_instance;
}
function OauthClientSecret_disabledAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function OauthClientSecret_disabledAt$_get_name_$ref_krpx55() {
  return (p0) => p0.k20();
}
function OauthClientSecret_disabledAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OauthClientSecret_disabledAt$_get_serializer_$ref_935ao() {
  return (p0) => p0.j2j();
}
function OauthClientSecret_disabledAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function OauthClientSecret_disabledAt$_get_annotations_$ref_89zibw() {
  return (p0) => p0.bz();
}
var OauthClientSecret_disabledAtClass;
function OauthClientSecret_disabledAt() {
  if (OauthClientSecret_disabledAtClass === VOID) {
    class $ {
      constructor() {
        OauthClientSecret_disabledAt_instance = this;
        var tmp = this;
        tmp.z2o_1 = lazy(OauthClientSecret_disabledAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a2p_1 = lazy(OauthClientSecret_disabledAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b2p_1 = lazy(OauthClientSecret_disabledAt$annotations$delegate$lambda);
        this.c2p_1 = null;
        this.d2p_1 = 'null';
      }
      k20() {
        var tmp0 = this.z2o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OauthClientSecret_disabledAt$_get_name_$ref_krpx55(), null);
        return tmp0.f2();
      }
      l2o(receiver) {
        return receiver.p2o_1;
      }
      m2j(receiver) {
        return this.l2o(receiver instanceof OauthClientSecret() ? receiver : THROW_CCE());
      }
      e2p(receiver, value) {
        return receiver.r2o(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OauthClientSecret() ? receiver : THROW_CCE();
        return this.e2p(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a2p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OauthClientSecret_disabledAt$_get_serializer_$ref_935ao(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b2p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OauthClientSecret_disabledAt$_get_annotations_$ref_89zibw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OauthClientSecret_disabledAt', VOID, VOID, [SerializableProperty()]);
    OauthClientSecret_disabledAtClass = $;
  }
  return OauthClientSecret_disabledAtClass;
}
var OauthClientSecret_disabledAt_instance;
function OauthClientSecret_disabledAt_getInstance() {
  if (OauthClientSecret_disabledAt_instance === VOID)
    new (OauthClientSecret_disabledAt())();
  return OauthClientSecret_disabledAt_instance;
}
//region block: exports
export {
  prepareOauthClientSecretFields as prepareOauthClientSecretFieldswj0m8xuir3ej,
};
//endregion

//# sourceMappingURL=OauthClientSecretFields.mjs.map
